import React, { Component } from 'react'
import Img from 'gatsby-image'

import { Container, Row, Column } from '../../global/grid/grid'
import Image from '../../global/media/Image'

import { TwoUpImage } from './styled-components'

class TwoUp extends Component {
  constructor (props) {
    super(props)
    this.vanishingPoint = 0
    this.latestKnownScrollY = 0
    this.ticking = false

    // bind events to context
    this.handleScroll = this.handleScroll.bind(this)
    this.setVanishingPoint = this.setVanishingPoint.bind(this)

    this.state = {
      positioningValue: 0
    }
  }
  componentDidMount () {
    document.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.setVanishingPoint)
    setTimeout(() => {
      this.setVanishingPoint()
    }, 1)
  }
  componentWillUnmount () {
    document.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.setVanishingPoint)
  }
  setVanishingPoint () {
    const scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop
    const twoUpTop = this.twoUpHolder.getBoundingClientRect().top
    const twoUpHeight = this.twoUpHolder.getBoundingClientRect().height
    this.vanishingPoint = scrollTop + twoUpTop + (twoUpHeight / 2)
  }
  handleScroll (e) {
    this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset
    // this.requestTick();
  }
  requestTick () {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this))
    }
    this.ticking = true
  }
  update () {
    this.ticking = false
    const posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight
    let positioningValue = 0
    if (posValCalc < 1 && posValCalc > 0) {
      positioningValue = Math.round((1 - posValCalc) * 100) / 100
    } else if (posValCalc < 0) {
      positioningValue = 1
    } else {
      positioningValue = 0
    }
    if (positioningValue !== this.state.positioningValue) {
      this.setState(
        {
          positioningValue: positioningValue
        }
      )
    }
  }
  render () {
    const { data, imageDictionary } = this.props
    return (
      <div ref={(div) => this.twoUpHolder = div}>
        <Row margins={[160, 150, 150]} style={{ alignItems: 'flex-start' }}>
          {
            data.images.map((imageKey, index) => {
              return (
                <Column offset={index === 0 ? 1 : 0} cw={5} key={index}>
                  <TwoUpImage imageIndex={index} color={data.color}>
                    <div>
                      <Image aspectHeight={5} aspectWidth={4} sizes={imageDictionary[imageKey].sizes} />
                    </div>
                    { data.direction === 'left' && index === 0 &&
                      <div className='twoUpBackground left'>
                        <div className='colorBlock' />
                      </div>
                    }
                    { data.direction === 'right' && index === 1 &&
                      <div className='twoUpBackground right'>
                        <div className='colorBlock' />
                      </div>
                    }
                  </TwoUpImage>
                </Column>
              )
            })
          }
        </Row>
      </div>
    )
  }
}

export default TwoUp



// WEBPACK FOOTER //
// ./src/components/modules/TwoUp/TwoUp.js